/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V6|V7 API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV7TagsCustomTargetTagValuesParams,
  GetV7TagsTargetTagValuesParams,
  PostV7TagsGlobalFilterTargetTagValuesParams,
  TagRequestArrayBody,
  TargetByTagResponse,
  TargetResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getCustomTargetKeyValue
 */
export const getV7TagsCustomTargetTagValues = (
  params?: MaybeRef<GetV7TagsCustomTargetTagValuesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TargetResponse>(
    { url: `/api/v7/tags/custom-target-tag-values`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7TagsCustomTargetTagValuesQueryKey = (
  params?: MaybeRef<GetV7TagsCustomTargetTagValuesParams>,
) => {
  return ['api', 'v7', 'tags', 'custom-target-tag-values', ...(params ? [params] : [])] as const;
};

export const getGetV7TagsCustomTargetTagValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TagsCustomTargetTagValues>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7TagsCustomTargetTagValuesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TagsCustomTargetTagValues>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TagsCustomTargetTagValuesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TagsCustomTargetTagValues>>> = ({
    signal,
  }) => getV7TagsCustomTargetTagValues(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TagsCustomTargetTagValues>>,
    TError,
    TData
  >;
};

export type GetV7TagsCustomTargetTagValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TagsCustomTargetTagValues>>
>;
export type GetV7TagsCustomTargetTagValuesQueryError = ErrorType<unknown>;

/**
 * @summary getCustomTargetKeyValue
 */

export function useGetV7TagsCustomTargetTagValues<
  TData = Awaited<ReturnType<typeof getV7TagsCustomTargetTagValues>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7TagsCustomTargetTagValuesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TagsCustomTargetTagValues>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TagsCustomTargetTagValuesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getTargetIdsListByTag
 */
export const postV7TagsGlobalFilterTargetTagValues = (
  tagRequestArrayBody: MaybeRef<TagRequestArrayBody>,
  params?: MaybeRef<PostV7TagsGlobalFilterTargetTagValuesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  tagRequestArrayBody = unref(tagRequestArrayBody);
  params = unref(params);

  return customAxiosInstance<TargetByTagResponse>(
    {
      url: `/api/v7/tags/global-filter/target-tag-values`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tagRequestArrayBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7TagsGlobalFilterTargetTagValuesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7TagsGlobalFilterTargetTagValues>>,
    TError,
    { data: BodyType<TagRequestArrayBody>; params?: PostV7TagsGlobalFilterTargetTagValuesParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7TagsGlobalFilterTargetTagValues>>,
  TError,
  { data: BodyType<TagRequestArrayBody>; params?: PostV7TagsGlobalFilterTargetTagValuesParams },
  TContext
> => {
  const mutationKey = ['postV7TagsGlobalFilterTargetTagValues'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7TagsGlobalFilterTargetTagValues>>,
    { data: BodyType<TagRequestArrayBody>; params?: PostV7TagsGlobalFilterTargetTagValuesParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7TagsGlobalFilterTargetTagValues(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7TagsGlobalFilterTargetTagValuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7TagsGlobalFilterTargetTagValues>>
>;
export type PostV7TagsGlobalFilterTargetTagValuesMutationBody = BodyType<TagRequestArrayBody>;
export type PostV7TagsGlobalFilterTargetTagValuesMutationError = ErrorType<unknown>;

/**
 * @summary getTargetIdsListByTag
 */
export const usePostV7TagsGlobalFilterTargetTagValues = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7TagsGlobalFilterTargetTagValues>>,
      TError,
      { data: BodyType<TagRequestArrayBody>; params?: PostV7TagsGlobalFilterTargetTagValuesParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7TagsGlobalFilterTargetTagValues>>,
  TError,
  { data: BodyType<TagRequestArrayBody>; params?: PostV7TagsGlobalFilterTargetTagValuesParams },
  TContext
> => {
  const mutationOptions = getPostV7TagsGlobalFilterTargetTagValuesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getTargetKeyValue
 */
export const getV7TagsTargetTagValues = (
  params?: MaybeRef<GetV7TagsTargetTagValuesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<TargetResponse>(
    { url: `/api/v7/tags/target-tag-values`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7TagsTargetTagValuesQueryKey = (
  params?: MaybeRef<GetV7TagsTargetTagValuesParams>,
) => {
  return ['api', 'v7', 'tags', 'target-tag-values', ...(params ? [params] : [])] as const;
};

export const getGetV7TagsTargetTagValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7TagsTargetTagValues>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7TagsTargetTagValuesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TagsTargetTagValues>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7TagsTargetTagValuesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7TagsTargetTagValues>>> = ({
    signal,
  }) => getV7TagsTargetTagValues(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7TagsTargetTagValues>>,
    TError,
    TData
  >;
};

export type GetV7TagsTargetTagValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7TagsTargetTagValues>>
>;
export type GetV7TagsTargetTagValuesQueryError = ErrorType<unknown>;

/**
 * @summary getTargetKeyValue
 */

export function useGetV7TagsTargetTagValues<
  TData = Awaited<ReturnType<typeof getV7TagsTargetTagValues>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7TagsTargetTagValuesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7TagsTargetTagValues>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7TagsTargetTagValuesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
